import request from "@/utils/request";

export function getOstans() {
  return request({
    url: "location/getostan",
    method: "post",
  });
}

export function getShahr(OstanID) {
  return request({
    url: "location/getShahr",
    method: "post",
    data: { OstanID: OstanID },
  });
}

export function getAllOstanCity() {
  return request({
    url: "location/getAllOstanCity",
    method: "post",
  });
}

export function cityAutoComplete(name) {
  return request({
    url: `city/autocomplete?name=${name}&count=10`,
    method: "post",
  });
}
